import React, { useState } from 'react';
import { EnvironmentFilled, PictureOutlined } from "@ant-design/icons";
import MapBox from '../components/map/mapBox';
import Channel from '../components/map/Channel';
import SiteDetails from '../components/map/siteDetails';
import { useData } from '../contexts/DataContext';

const MapView = () => {
  const { sites, loading, error, selectedData } = useData();
  const [localTab, setLocalTab] = useState('map');
  const [showAlert, setShowAlert] = useState(false);

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  if (error) {
    return <div className="flex items-center justify-center h-screen text-red-500">Error: {error}</div>;
  }

  return (
    <div className="h-screen flex flex-col bg-gray-100 overflow-hidden">
      <div className="flex-grow flex overflow-hidden">
        {/* Side Content */}
        <div className="w-72 bg-white shadow-lg flex flex-col overflow-hidden border-r border-gray-200">
          <div className="overflow-y-auto flex-grow px-4">
            <Channel sites={sites} />
          </div>
        </div>



      {/* Main Content */}
        <div className="flex-grow bg-white shadow-lg flex flex-col overflow-hidden relative">
          <div className="flex justify-end p-4 space-x-2 flex-shrink-0">
            <button
              onClick={() => setLocalTab('map')}
              className={`flex items-center justify-center px-4 py-2 rounded-md transition ${
                localTab === 'map' ? 'bg-blue-500 text-white' : 'bg-gray-200 hover:bg-gray-300'
              }`}
            >
              <EnvironmentFilled className="mr-2" /> 
              <span>MAP</span>
            </button>
            <button
              onClick={() => setLocalTab('site_view')}
              className={`flex items-center justify-center px-4 py-2 rounded-md transition ${
                localTab === 'site_view' ? 'bg-blue-500 text-white' : 'bg-gray-200 hover:bg-gray-300'
              }`}
            >
              <PictureOutlined className="mr-2" /> 
              <span>SITE DETAILS</span>
            </button>
          </div>
          <div 
            className="flex-grow overflow-hidden relative"
            onMouseEnter={() => setShowAlert(true)}
            onMouseLeave={() => setShowAlert(false)}
          >
            {localTab === "map" && <MapBox sites={sites} />}
            {localTab === "site_view" && <SiteDetails sites={sites} selectedData={selectedData} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapView;
